export const LIVE_LINK_MODAL_STATE = {
  HIDE: 0,
  SHOW_ALREADY_FINISHED: 1,
  SHOW_LEAVE: 2,
} as const

export type LIVE_LINK_MODAL_STATE = (typeof LIVE_LINK_MODAL_STATE)[keyof typeof LIVE_LINK_MODAL_STATE]

export const LIVE_STREAM_ROLE = {
  HOST: 'host',
  AUDIENCE: 'audience',
} as const

export type LIVE_STREAM_ROLE = (typeof LIVE_STREAM_ROLE)[keyof typeof LIVE_STREAM_ROLE]
import { User } from '@/types/user'
import { UserProfile } from '@/types/userProfile'

export const LIVE_STREAMING_STATUS = {
  LIVE_STERAMING: 1,
  NOT_STREAMING: 2,
}

export type LIVE_STREAMING_STATUS = (typeof LIVE_STREAMING_STATUS)[keyof typeof LIVE_STREAMING_STATUS]

export interface LiveStream {
  liveStreamNo: number
  userNo: number
  title: string
  liveUrl: string
  liveStartDatetime: string | undefined
  liveEndDatetime: string | undefined
  status: LIVE_STREAMING_STATUS
  channel: string
  createdAt: string
  updatedAt: string
  userProfile?: UserProfile
  liveOrders?: LiveOrder[]
}

export const LIVE_STREAMING_MUTE_STATUS = {
  MUTING: 1,
  RELEASING: 2,
}

export type LIVE_STREAMING_MUTE_STATUS = (typeof LIVE_STREAMING_MUTE_STATUS)[keyof typeof LIVE_STREAMING_MUTE_STATUS]

export interface LiveStreamMuteMap {
  liveStreamMuteMapNo: number
  liveStreamNo: number
  audienceNo: number
  status: LIVE_STREAMING_MUTE_STATUS
  mutedAt: string
  releasedAt: string | null
  createdAt: string
  updatedAt: string
  liveStream?: LiveStream
  audienceProfile?: UserProfile
}

export const LIVE_STREAMING_USER_ROLE = {
  HOST: 1,
  AUDIENCE: 2,
}

export type LIVE_STREAMING_USER_ROLE = (typeof LIVE_STREAMING_USER_ROLE)[keyof typeof LIVE_STREAMING_USER_ROLE]

export const LIVE_STREAMING_USER_STATUS = {
  JOINING: 1,
  LEAVING: 2,
}

export type LIVE_STREAMING_USER_STATUS = (typeof LIVE_STREAMING_USER_STATUS)[keyof typeof LIVE_STREAMING_USER_STATUS]

export interface LiveStreamUserMap {
  liveStreamUserMapNo: number
  liveStreamNo: number
  userNo: number
  channel: string
  role: LIVE_STREAMING_USER_ROLE
  status: LIVE_STREAMING_USER_STATUS
  joinedAt: string
  leftAt: string | null
  createdAt: string
  updatedAt: string
  liveStream?: LiveStream
  userProfile?: UserProfile
}

export const LIVE_STREAMING_BLOCK_STATUS = {
  BLOCKING: 1,
  RELEASING: 2,
}

export type LIVE_STREAMING_BLOCK_STATUS = (typeof LIVE_STREAMING_BLOCK_STATUS)[keyof typeof LIVE_STREAMING_BLOCK_STATUS]

export interface LiveStreamBlockMap {
  hostNo: number
  audienceNo: number
  status: LIVE_STREAMING_BLOCK_STATUS
  blockedAt: string
  releasedAt: string | null
  createdAt: string
  updatedAt: string
  hostProfile?: UserProfile
  audienceProfile?: UserProfile
}

export const PAYMENT_METHODS = {
  CREDIT_CARD: 1,
  CASH: 2,
} as const

export const PAYMENT_STATUSES = {
  INITIAL: 1, // 初期状態
  AUTHORIZED: 2, // 限度額確保
  PROCESSED: 3, // 処理済、依頼者への請求が発生する
  REFUNDED: 99, // 返金
} as const

export type PAYMENT_METHOD = (typeof PAYMENT_METHODS)[keyof typeof PAYMENT_METHODS]

export type PAYMENT_STATUS = (typeof PAYMENT_STATUSES)[keyof typeof PAYMENT_STATUSES]

export interface LiveOrder {
  liveOrderNo: number
  liveStreamNo: number
  buyerNo: number
  amount: number
  paymentStatus: PAYMENT_STATUS
  paymentMethod: PAYMENT_METHOD | null
  memo: string | null
  gmoOrderId: string | null
  processedAt: string | null
  createdAt: string
  updatedAt: string
  liveStream?: LiveStream
  buyer: UserProfile
  liveOrdersProductsMappings?: LiveOrdersProductsMapping[]
}

export interface LiveProduct {
  productNo: number
  userNo: number
  name: string
  amount: number
  piece: number
  count: number
  imgS3Key: string
  isSocialTipping: boolean
  isActive: boolean
  isDeleted: boolean
  createdAt: string
  updatedAt: string
  user?: User
  liveOrdersProductsMappings?: LiveOrdersProductsMapping[]
  img?: string
}

export interface LiveOrdersProductsMapping {
  mappingNo: number
  liveOrderNo: number
  liveProductNo: number
  piece: number
  createdAt: string
  updatedAt: string
  liveOrder?: LiveOrder
  liveProduct?: LiveProduct
}

export interface LiveInfo {
  productNo: number | undefined
  userNo: number | undefined
  name: string | undefined
  amount: number | undefined
  piece: number | undefined
  img: File | string | undefined
  isActive: boolean
  edit: boolean
  isDeleted: boolean
  isSocialTipping?: boolean
}

export type GetLiveStreamsResponse = {
  meta: {
    perPage: number
    totalRows: number
  }
  data: {
    liveStreams: LiveStream[]
  }
}

export type GetLiveStreamDetailResponse = {
  data: {
    liveStream: LiveStream
  }
}

export type LiveStreamPurchasedProduct = {
  id: number
  processedAt: string
  name: string
  amount: number
  piece: number
  host: UserProfile
  buyer: UserProfile
}

export interface GetAgoraInfoResponse {
  data: GetAgoraInfoResponseData
}

export interface GetAgoraInfoResponseData {
  appId: string
  appCertificate: string
}

export interface GetAgoraAccessTokensParams {
  uid: string
  channel: string
}

export interface GetAgoraAccessTokensResponseData {
  rtcToken: string
  rtmToken: string
}

export interface GetAgoraAccessTokensResponse {
  data: GetAgoraAccessTokensResponseData
}

export interface HasLiveStreamingParams {
  hostId: string
}

export interface HasLiveStreamingResponse {
  data: HasLiveStreamingResponseData
}

export interface HasLiveStreamingResponseData {
  status: boolean
  isLive: boolean
  liveStreamNo: number
  channel: string
}

export interface JoinLiveStreamByHostRequest {
  hostNo: number
  title: string
  channel: string
}

export interface JoinLiveStreamByHostResponse {
  data: JoinLiveStreamByAudienceResponseData
}

export interface JoinLiveStreamByHostResponseData {
  status: boolean
  liveStream: LiveStream | null
}

export interface LeaveLiveStreamByHostRequest {
  liveStreamNo: number
}

export interface JoinLiveStreamByAudienceRequest {
  liveStreamNo: number
  audienceNo: number
}

export interface JoinLiveStreamByAudienceResponse {
  data: JoinLiveStreamByAudienceResponseData
}

export interface JoinLiveStreamByAudienceResponseData {
  status: boolean
  liveStream: LiveStream | null
  blockMap: LiveStreamBlockMap | null
  muteMap: LiveStreamMuteMap | null
}

export interface LeaveLiveStreamByAudienceRequest {
  liveStreamNo: number
  audienceNo: number
}

export interface BlockAudienceRequest {
  hostNo: number
  audienceNo: number
}

export interface ReleaseBlockedAudienceRequest {
  hostNo: number
  audienceNo: number
}

export interface MuteAudienceRequest {
  liveStreamNo: number
  audienceNo: number
}

export interface ReleaseMutedAudienceRequest {
  liveStreamNo: number
  audienceNo: number
}

export const COMMENT_PREFIX = {
  HOST_COMMENT: 'HostComment',
  AUDIENCE_COMMENT: 'AudienceComment',
  SYSTEM: 'System',
  JOIN: 'Join',
  LEAVE: 'Leave',
  PURCHASED: 'Purchased',
  BLOCK: 'Block',
  RELEASE_BLOCK: 'ReleaseBlock',
  MUTE: 'Mute',
  RELEASE_MUTE: 'ReleaseMute',
  NAGESEN: 'Nagesen',
  CAMERA_MUTED: 'CameraMuted',
  CAMERA_UNMUTED: 'CameraUnmuted',
  MIC_MUTED: 'MicMuted',
  MIC_UNMUTED: 'MicUnmuted',
  UPDATE_PRODUCTS: 'UpdateProducts',
  JOIN_FOR_PURCHASE: 'JoinForPurchase',
  LEAVE_FOR_PURCHASE: 'LeaveForPurchase',
  JOIN_FOR_PURCHASE_FAILED: 'JoinForPurchaseFailed',
} as const

export type COMMENT_PREFIX = (typeof COMMENT_PREFIX)[keyof typeof COMMENT_PREFIX]

export type CommentListElementType = {
  prefix: string
  params: CommentParamType
  body: string
}

export type CommentParamType = {
  indicateId: string
  senderName?: string
  iconUrl?: string
  productName?: string
  amount?: string
  isSocialTipping?: boolean
  buyerName?: string
}

export type CommonPrefixType =
  | typeof COMMENT_PREFIX.JOIN
  | typeof COMMENT_PREFIX.LEAVE
  | typeof COMMENT_PREFIX.BLOCK
  | typeof COMMENT_PREFIX.RELEASE_BLOCK
  | typeof COMMENT_PREFIX.MUTE
  | typeof COMMENT_PREFIX.RELEASE_MUTE
  | typeof COMMENT_PREFIX.CAMERA_MUTED
  | typeof COMMENT_PREFIX.CAMERA_UNMUTED
  | typeof COMMENT_PREFIX.MIC_MUTED
  | typeof COMMENT_PREFIX.MIC_UNMUTED
  | typeof COMMENT_PREFIX.UPDATE_PRODUCTS
  | typeof COMMENT_PREFIX.JOIN_FOR_PURCHASE
  | typeof COMMENT_PREFIX.LEAVE_FOR_PURCHASE
  | typeof COMMENT_PREFIX.JOIN_FOR_PURCHASE_FAILED
export type JoinOrLeavePrefixType =
  | typeof COMMENT_PREFIX.JOIN
  | typeof COMMENT_PREFIX.LEAVE
  | typeof COMMENT_PREFIX.JOIN_FOR_PURCHASE
  | typeof COMMENT_PREFIX.LEAVE_FOR_PURCHASE
  | typeof COMMENT_PREFIX.JOIN_FOR_PURCHASE_FAILED
export type CommentOnlyPrefixType =
  | typeof COMMENT_PREFIX.HOST_COMMENT
  | typeof COMMENT_PREFIX.AUDIENCE_COMMENT
  | typeof COMMENT_PREFIX.SYSTEM
export type TemplateOnlyPrefixType =
  | typeof COMMENT_PREFIX.CAMERA_MUTED
  | typeof COMMENT_PREFIX.CAMERA_UNMUTED
  | typeof COMMENT_PREFIX.MIC_MUTED
  | typeof COMMENT_PREFIX.MIC_UNMUTED
  | typeof COMMENT_PREFIX.UPDATE_PRODUCTS

export interface GetBlockMapRequest {
  hostId: string
  audienceId: string
}

export interface GetBlockMapResponse {
  data: GetBlockMapResponseData
}

export interface GetBlockMapResponseData {
  status: boolean
  blockMap: LiveStreamBlockMap | null
}

export interface GetMuteMapRequest {
  liveStreamNo: number
  audienceId: string
}

export interface GetMuteMapResponse {
  data: GetMuteMapResponseData
}

export interface GetMuteMapResponseData {
  status: boolean
  muteMap: LiveStreamMuteMap | null
}

export interface AudienceObject {
  userProfile: UserProfile
  blockMap: LiveStreamBlockMap | null
  muteMap: LiveStreamMuteMap | null
}

export interface GetAudiencesRequest {
  liveStreamNo: number
  keyword: string
  limit: number
  offset: number
}

export interface GetAudiencesResponseMeta {
  perPage: number
  totalRows: number
}

export interface GetAudiencesResponseData {
  status: boolean
  audiences: AudienceObject[]
}

export interface GetAudiencesResponse {
  meta: GetAudiencesResponseMeta
  data: GetAudiencesResponseData
}

export interface GetProductsRequest {
  hostId: string
}

export interface GetProductsResponseData {
  status: boolean
  liveProducts: LiveProduct[]
}

export interface GetProductsResponse {
  data: GetProductsResponseData
}

export type HostedLiveStreamSummary = {
  totalLiveStreams: number
  totalTransactions: number
  totalTransactionAmount: number
  totalRevenue: number
}

export interface UpProductCountRequest {
  productNo: number
}

export interface UpProductCountResponseData {
  status: boolean
  succeed: boolean
}

export interface UpProductCountResponse {
  data: UpProductCountResponseData
}

export interface DownProductCountRequest {
  productNo: number
}

export interface DownProductCountResponseData {
  status: boolean
}

export interface DownProductCountResponse {
  data: DownProductCountResponseData
}

export interface GenerateGmoLinkplusUrlForLiveStreamRequest {
  liveStreamNo: number
  audienceNo: number
  hostId: string
  productNo: number
  amount: number
}

export interface GenerateGmoLinkplusUrlForLiveStreamResponseData {
  data: {
    url: string
  }
}

export interface GenerateGmoLinkplusUrlForLiveStreamResponse {
  data: GenerateGmoLinkplusUrlForLiveStreamResponseData
}

export interface GetLiveOrderRequest {
  liveOrderNo: number
}

export interface GetLiveOrderResponseData {
  status: boolean
  liveOrder: LiveOrder | null
}

export interface GetLiveOrderResponse {
  data: GetLiveOrderResponseData
}
